// extracted by mini-css-extract-plugin
export default {"cell":"EmptyRow_cell__ExQ19"};